import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

class StepHeader extends Component {
    render() {
        const { steps } = this.props;

        return (
            <div className="stepper">
                {steps.map((step, i) => (
                    <div className={`stepper-number ${step.status}`} key={i}>
                        {i !== steps.length && (
                            <div aria-hidden={step.status === 'process' ? false : true} className="stepper-label">
                                {step.title}
                                {step.status === 'process' ? (
                                    <hr
                                        aria-hidden
                                        className="fs-bar orange"
                                        style={{ borderTop: '2px solid #ff5d43', width: '80px' }}
                                    />
                                ) : (
                                    ''
                                )}
                            </div>
                        )}
                        <div className={i !== 0 ? 'separator-dot' : ''}> </div>
                    </div>
                ))}
            </div>
        );
    }
}

StepHeader.propTypes = {
    steps: PropTypes.array.isRequired,
};
export default injectIntl(StepHeader);
